import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BsGithub } from "react-icons/bs";
import { CgWebsite } from "react-icons/cg";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Body style={{ display: "flex", flexDirection: "column", padding: "1.4rem" }}>
        <Card.Title style={{ marginBottom: "0.7rem", fontSize: "1rem", fontWeight: 700 }}>
          {props.title}
        </Card.Title>
        <Card.Text style={{ textAlign: "left", marginBottom: "1.1rem", flex: 1, fontSize: "0.875rem", lineHeight: 1.65, color: "var(--muted)" }}>
          {props.description}
        </Card.Text>
        <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
          {props.ghLink && (
            <Button variant="primary" href={props.ghLink} target="_blank">
              <BsGithub /> &nbsp;{props.isBlog ? "Blog" : "GitHub"}
            </Button>
          )}
          {!props.isBlog && props.demoLink && (
            <Button variant="primary" href={props.demoLink} target="_blank">
              <CgWebsite /> &nbsp;Demo
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
